import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilState, useRecoilValue } from "recoil";
import { lowerLanguage } from "src/i18n";
import { useGetCookie } from "src/networking/terminals";
import { atomReloadCookie, selectorCookieTemplate } from "src/storage";

const cookieStartTemplatePath = "/cookieTemplates/templateCookieStart.txt";
const cookieEndTemplatePath = "/cookieTemplates/templateCookieEnd.txt";

export const useCookie = () => {
  const { t } = useTranslation();

  const { crossGate: getCookie } = useGetCookie();

  const cookieTemplates = useRecoilValue(selectorCookieTemplate);

  const [templatesStart, setTemplatesStart] = useState("");
  const [templatesEnd, setTemplatesEnd] = useState("");
  const [isReloaded, setReloaded] = useRecoilState(atomReloadCookie);

  useEffect(() => {
    if (!isReloaded) {
      setReloaded(true);
      location.reload();
    }
  }, [isReloaded]);

  useEffect(() => {
    const fetchTxtTemp = async () => {
      try {
        const respStart = await fetch(cookieStartTemplatePath);
        const textStart = await respStart.text();
        setTemplatesStart(textStart);

        const respEnd = await fetch(cookieEndTemplatePath);
        const textEnd = await respEnd.text();
        setTemplatesEnd(textEnd);
      } catch (err) {
        console.error("Error fetching text file:", err);
      }
    };

    fetchTxtTemp();
    /*if (cookieTemplates) {
      getCookie(
        {
          baseURL: cookieTemplates?.startTemplate?.[lowerLanguage] || "",
        },
        {
          onSuccess: (template) => {
            setTemplatesStart(template);
          },
        }
      );

      getCookie(
        {
          baseURL: cookieTemplates?.endTemplate?.[lowerLanguage] || "",
        },
        {
          onSuccess: (template) => {
            setTemplatesEnd(template);
          },
        }
      );
    }*/
  }, [lowerLanguage, cookieTemplates]);

  return { t, templatesStart, templatesEnd };
};
